<template>
  <basic-slideout
    :open="open"
    @update:open="$emit('update:open', $event)"
  >
    <template v-slot:header>
      <h1>{{ _mft('crm:leadDealCard.updateDeal') }}</h1>
    </template>

    <template v-slot:body>
      <input-select
        :content="deal.type"
        @update:content="updateField('type', $event)"
        :options="typeOptions"
        valueSpecification="id"
        labelSpecification="type_name"
        :label="_mft('crm:leadDealCard.type')"
        required
        placeholder=""
        name="type"
      />

      <input-select
        :content="deal.status"
        @update:content="updateField('status', $event)"
        :options="statusOptions"
        :label="_mft('crm:leadDealCard.status')"
        required
        placeholder=""
        name="status"
      />

      <input-number
        :label="_mft('crm:leadDealCard.estimatedValue')"
        :content="deal.value"
        name="value"
        @update:content="updateField('value', $event)"
      />

      <div class="flex items-center justify-between mt-4">
        <a
          v-if="deleteUrl"
          :href="deleteUrl"
          class="text-sm font-semibold text-myflowRed-700"
        >
          {{ _mft('crm:leadDealCard.deleteDeal') }}
        </a>
        <span v-else></span>

        <input-button
          :label="_mft('shared:action.update')"
          type="success"
          :busy="busy"
          :disabled="disabled"
          @click="$emit('submit')"
        />
      </div>
    </template>
  </basic-slideout>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    deal: {
      type: Object,
      required: true,
    },
    typeOptions: {
      type: Array,
      default: () => [],
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    busy: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    deleteUrl: {
      type: String,
      default: '',
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit('update:deal', {
        ...this.deal,
        [field]: value,
      });
    },
  },
};
</script>
